export default "/images/vendor/flag-icon-css/flags/4x3/gi.svg?9aac5eefeebd80bdee3b666665780625";